import React, { useContext } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import SimpleHeader from "../components/SimpleHeader";
import { LanguageContext } from "../languages/LanguageContext";
import GalleryPreview from "../components/GalleryPreview";
import PageTitle from "../components/PageTitle";

const Accommodation = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='Accommodation' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"accommodation"}
                    route={"accommodation"}
                    url={"accommodation"}
                />
                <div className='accommodation-container flex gap-2 jc-sb wrap max-w'>
                    <div className='introduction-container flex gap-2 wrap'>
                        <div className='content-container'>
                            <h2>{translations[language]["aboutApartmentTitle"]} - Klagenfurt</h2>
                            <p>{translations[language]["aboutApartment"]}</p>
                            <div className='address-container flex ai-c'>
                                <p><b>Address: </b>Ankershofenstraße 8, Stiege 2 9020 Klagenfurt</p>
                            </div>
                            <div className='image-container'>
                                <GalleryPreview
                                    folder={'accommodation-klagenfurt/'}
                                    imageCount={15}
                                    prefix={'room-'}
                                />
                            </div>
                        </div>
                        <div className='content-container w-full'>
                            <h2>{translations[language]["aboutApartmentTitle"]} - Althofen</h2>
                            <div className='image-container'>
                                <GalleryPreview
                                    folder={'accommodation-althofen/'}
                                    imageCount={10}
                                    prefix={'room-'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='video-container flex col gap-sm max-w jc-sb'>
                        <iframe
                            src="https://www.youtube.com/embed/4A8sAzAi79g"
                            title="Klagenfurt am Wörthersee aus der Drohne 🇦🇹 Österreich | Kärnten | Drohne | 4K"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                            allowFullScreen
                        />
                        <iframe
                            src="https://www.youtube.com/embed/VGgOOeya8us"
                            title="Klagenfurt am Wörthersee 🇦🇹 Austria | Carinthia | 4K"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                            allowFullScreen
                        />
                        <p>{translations[language]["aboutVideo"]} <a href='https://www.youtube.com/@Travel-memories' target='_blank' rel="noreferrer">{translations[language]["videoClick"]}</a></p>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
};

export default Accommodation;